
interface CubeGameDisplayProps {
  number: number;
  answer: number;
  showAnswer: boolean;
  isBlocked?: boolean;
}

const funnyMessages = [
  "Cubes are feeling dizzy! Let them settle 🎲",
  "Your cube powers need a quick recharge 🔋",
  "Even cubic numbers need a breather! 📦",
  "Slow down, math explorer! 🗺️",
  "Cubing at light speed? Let's take it easy! 🌟",
  "Time for a cubic coffee break! ☕",
  "Your enthusiasm is cube-tastic! But let's pace ourselves 🎯",
  "The cube gods request a moment of peace 🧊"
];

export const CubeGameDisplay: React.FC<CubeGameDisplayProps> = ({
  number,
  answer,
  showAnswer,
  isBlocked,
}) => {
  const randomMessage = () => funnyMessages[Math.floor(Math.random() * funnyMessages.length)];

  return (
    <div className="text-center mb-8">
      <div className="bg-gradient-to-br from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 p-8 rounded-xl border border-emerald-100 dark:border-emerald-800 transition-colors duration-200">
        <h2 className="text-5xl font-bold mb-4 bg-gradient-to-r from-emerald-600 to-teal-600 dark:from-emerald-400 dark:to-teal-400 bg-clip-text text-transparent">
          {number}³ = {showAnswer ? answer : '?'}
        </h2>
        <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
          {isBlocked ? (
            <span className="text-amber-600 dark:text-amber-400">{randomMessage()}</span>
          ) : (
            showAnswer ? 'Press → or Space for next question' : 'Press → or Space to see answer'
          )}
        </p>
      </div>
    </div>
  );
};